import React from 'react'
import { SidebarContainer, ContentContainer } from './styled-compoents'
import PropTypes from 'prop-types'
import { AnimatePresence } from 'framer-motion'
import { sidebarSideOptions } from './constants'

const SidebarComponent = ({
  isOpen = true,
  onExitComplete,
  side = sidebarSideOptions.RIGHT,
  children,
  maxWidth = '25vw',
  topOffset,
  ...props
}) => {
  const isRight = side === sidebarSideOptions.RIGHT

  return (
    <AnimatePresence onExitComplete={onExitComplete}>
      {isOpen && (
        <SidebarContainer
          isRight={isRight}
          initial={{ x: isRight ? '100%' : '-100%' }}
          animate={{ x: 0 }}
          exit={{ x: isRight ? '100%' : '-100%' }}
          transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20,
            mass: 0.5
          }}
          maxWidth={maxWidth}
          topOffset={topOffset}
          {...props}
        >
          <ContentContainer>{children}</ContentContainer>
        </SidebarContainer>
      )}
    </AnimatePresence>
  )
}

SidebarComponent.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  side: PropTypes.oneOf(Object.values(sidebarSideOptions)),
  topOffset: PropTypes.string
}

export default SidebarComponent
